import { instagramApi } from "@/api/instagram";
import { getOrigin } from "@/utils/origin";
import { defineStore } from "pinia";

export const useInstagramStore = defineStore("instagram", () => {

  const connectInstagram = async (rewrite?: boolean) => {
    const redirect_uri = getOrigin() + "/connect/instagram"
    const { url } = await instagramApi.getConnectLink(redirect_uri, rewrite) 
    window.location.href = url
  }

  const confirmConnectInstagram = async ({ code, state }: { code: string, state: string }) => {
    const redirect_uri = getOrigin() + "/connect/instagram"
    const resp = await instagramApi.connectToInstagram({ code, state, redirect_uri })
    return resp
  }

  return { 
    connectInstagram,
    confirmConnectInstagram
  }

})